import { IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { take } from 'rxjs/operators';
import { IGetMoreRowsParams, INbGridOptions } from './nb-grid';

export class NbGridLazyLoadDataSource implements IServerSideDatasource {
  gridOptions: INbGridOptions;

  // how many pages available on server side data source
  totalPages = 0;

  // last page fetched from server side data source
  lastPage = 0;

  constructor(options: INbGridOptions) {
    this.gridOptions = options;
  }

  // when grid infinite scrolling triggered, this method will be called to retrieve lazy loaded data
  getRows(params: IServerSideGetRowsParams) {
    const options: IGetMoreRowsParams = {
      totalPages: this.totalPages,
      lastPage: this.lastPage,
      startRow: params.request.startRow,
      endRow: params.request.endRow,
    };

    if (params.request.sortModel && params.request.sortModel.length > 0) {
      const sortModel = params.request.sortModel[0];
      options.sortBy = sortModel.colId;
      options.sortType = sortModel.sort;
    }

    this.gridOptions
      .getMoreRows(options)
      .pipe(take(1))
      .subscribe(
        ({ delta, totalPages, lastPage }) => {
          this.totalPages = totalPages || this.totalPages;
          this.lastPage = lastPage || this.lastPage;

          params.successCallback(delta, this.lastPage >= this.totalPages ? this.totalPages : -1);
        },
        () => params.failCallback(),
      );
  }

  // optional destroy method, do clean up here
  destroy() {
    this.totalPages = 0;
    this.lastPage = 0;
  }
}
